import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useChartMakeRunNowLogic } from 'shared-modules/services/hooks/chartMake';
import { useSummaryInfo } from 'shared-modules/services/hooks';
import { openBuilderAddToPortfolioFailModal, openBuilderAddToPortfolioSuccessModal } from '../../../../redux/actions';
import RunNow from '../RunAutoTradeComponents/RunNow';

const ChartMakeRunNowConfirmation = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();

  const openSuccessModal = useCallback(
    (orderName) => {
      dispatch(openBuilderAddToPortfolioSuccessModal({ orderName }));
    },
    [dispatch],
  );

  const openFailModal = useCallback(
    (orderName, fullErrorText) => {
      dispatch(openBuilderAddToPortfolioFailModal({ orderName, fullErrorText }));
    },
    [dispatch],
  );

  const runNowLogic = useChartMakeRunNowLogic({
    isModalOpen: isOpen,
    closeModal,
    handleSuccess: openSuccessModal,
    handleFail: openFailModal,
  });

  const {
    receivedMargin,
    effectiveMargin,
    orderableMargin,
    instrumentGroups,
    orderingRequiredMargin,
    positionRequiredMargin,
  } = useSummaryInfo();

  const chartData = useMemo(
    () => ({
      effectiveMargin,
      orderableMargin,
      receivedMargin,
      instrumentGroups,
      orderingRequiredMargin,
      positionRequiredMargin,
    }),
    [
      effectiveMargin,
      orderableMargin,
      receivedMargin,
      instrumentGroups,
      orderingRequiredMargin,
      positionRequiredMargin,
    ],
  );
  chartData.consumedMargin = runNowLogic.requiredMargin.get;

  return (
    <RunNow
      isOpen={isOpen}
      closeModal={closeModal}
      runNowLogic={runNowLogic}
      marginRequired={runNowLogic.requiredMargin}
      submitSettings={runNowLogic.submit}
      setsSettings={runNowLogic.sets}
    />
  );
};

ChartMakeRunNowConfirmation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default memo(ChartMakeRunNowConfirmation);
